import { render, staticRenderFns } from "./ResidentList.vue?vue&type=template&id=1e190582&scoped=true&lang=pug"
import script from "./ResidentList.vue?vue&type=script&lang=ts"
export * from "./ResidentList.vue?vue&type=script&lang=ts"
import style0 from "./ResidentList.vue?vue&type=style&index=0&id=1e190582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e190582",
  null
  
)

export default component.exports